import { useTranslation, withTranslation } from "react-i18next"
import { TableContainer, Table, TableRow, TableHead, TableCell, TableBody } from '@mui/material/';
import React from "react";
import '../../utils/common.scss';
import SETTINGS from './../../utils/constants';

const PriceTable=()=>{
    const {t} = useTranslation();
    const translateArray = t('priceInfo', {returnObjects: true})
    
    return(
        <TableContainer>
            <Table size='medium'>
                <TableHead>
                    <TableRow>
                        {translateArray?.tableHead?.map((item, index)=>{
                            return <TableCell key={index} sx={{fontSize: {xs:'16px', md: '32px'}, fontWeight: 700, lineHeight: '48px', color: SETTINGS.DEEP_COLOR}}>{item}</TableCell>
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {translateArray?.tableBody?.map((item)=>{
                        return(
                            <TableRow key={item.id} style={{whiteSpace: 'pre-line'}}>
                                <TableCell sx={{fontSize:{xs:'16px', md: '20px'}, fontWeight: 450, color: SETTINGS.SECONDARY_COLOR}}>
                                    {item.name}
                                </TableCell>
                                <TableCell sx={{fontSize:{xs:'16px', md: '20px'}, fontWeight: 450, color: SETTINGS.SECONDARY_COLOR}}>
                                    {item.price}
                                </TableCell>
                                {/* <TableCell sx={{fontSize:{xs:'16px', md: '20px'}, fontWeight: 450, color: SETTINGS.SECONDARY_COLOR}}>
                                    {item.package}
                                </TableCell> */}
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default withTranslation()(PriceTable)